<template>
	<div class="time-range-read-only time-range-read-only-box" style="margin: 10px 0 10px 0">
		<egranty-section-divider
			:text="numberOfModules > 1 ? 'Ramy czasowe modułu ' + moduleNumber : 'Ramy czasowe projektu'"
			icon="date_range"
			:show-print-info="showPrintInfo"
		></egranty-section-divider>

		<div class="ma-3 module-dates">
			<v-flex xs12 md12>
				<display-text-component
					class="modular"
					:label="numberOfModules > 1 ? 'Data rozpoczęcia modułu' : 'Data rozpoczęcia projektu'"
					:value="value.start"/>
			</v-flex>

			<v-flex xs12 md12>
				<display-text-component
					class="modular"
					:label="numberOfModules > 1 ? 'Data zakończenia modułu' : 'Data zakończenia projektu'"
					:value="value.end"/>
			</v-flex>
		</div>
	</div>
</template>

<script>
	import EgrantySectionDivider from "../../../../../genericComponents/EgrantySectionDivider";
	import DisplayTextComponent from "../DisplayTextComponent";

	export default {
		name: "ChooseStartEndReadOnlyView",
		components: {DisplayTextComponent, EgrantySectionDivider},

		props: {
			numberOfModules: {
				default: 0
			},
			moduleNumber: {
				default: ''
			},
			value: Object,
			showPrintInfo: {
				type: Boolean, default: false
			}
		},
	};
</script>

<style scoped>
	.time-range-read-only {
		padding-top: 2px !important;
		padding-bottom: 2px !important;
	}

	@media print {
		.time-range-read-only-box {
			padding-top: 2px !important;
			padding-bottom: 2px !important;
			border: 1px solid grey;
		}
	}
</style>